import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbConfigBiccateca } from 'app/abstract/full-pages/locker/config-biccateca.abstract';

@Injectable({ providedIn: 'root' })
export class ConfigBiccatecaService extends AbConfigBiccateca {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigBiccateca() {
    return this.get(`config_lockers/${1}`);
  }

  public getConfigMeuLocker() {
    return this.get(`config_lockers/meuLocker/`);
  }

  public getConfigPadrao() {
    return this.get(`config_lockers/padrao/`);
  }

  public salvar(entity: any) {
    return this.save("config_dispositivos/", entity);
  }
}